import { Card, Radio, RadioChangeEvent, Space } from 'antd';
import React, { FunctionComponent } from 'react';
import { Experiment, Experiments, useExperiment } from '../../helpers/experiments';
import { VariantOf, VariantsConfig } from '../../helpers/experiments/Experiment';
import { ExperimentStorage } from '../../helpers/experiments/ExperimentStorage';
import { QueryParamExperiment } from '../../helpers/experiments/QueryParamExperiment';

export const ExperimentControls: FunctionComponent = () => {
  const experiments = Object.values(Experiments).filter(
    (experiment) => experiment !== Experiments.Dev && experiment.isActive
  );

  return (
    <div style={{ width: 258 }}>
      {experiments.map((experiment) => (
        <Space key={experiment.name} direction="vertical" size="small">
          <ExperimentControl experiment={experiment as unknown as Experiment<VariantsConfig>} />
        </Space>
      ))}
    </div>
  );
};

const ExperimentControl: FunctionComponent<{
  experiment: Experiment<VariantsConfig>;
}> = (props) => {
  const { experiment } = props;
  // Suppress the auto viewed as this toolbar renders on every screen.
  const variant = useExperiment(experiment, { suppressViewTracking: true });

  function onChange(event: RadioChangeEvent) {
    const newVariant = event.target.value as VariantOf<VariantsConfig>;
    experiment.overrideVariant(newVariant);
    if (experiment instanceof QueryParamExperiment) {
      ExperimentStorage.updateQueryParam(experiment, newVariant);
    } else {
      ExperimentStorage.storeSingle(experiment, newVariant);
    }
  }

  // Add label so devs can see which experiments are currently overridden.
  // Once an override is put in localstorage it stays there until
  // manually removed.
  const overrideText = experiment.isOverridden ? ' (overridden)' : '';

  return (
    <Card title={experiment.name + overrideText} size="small" style={{ width: 258 }}>
      <Radio.Group onChange={onChange} value={variant}>
        <Space direction="vertical" size="small">
          {experiment.allVariants.map((variant) => (
            <Radio value={variant} key={variant}>
              {variant}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
    </Card>
  );
};
